import styled from 'styled-components';

export const Marker = styled.div<{ $markerRem: number }>`
  bottom: ${(props): number => props.$markerRem}rem;
  height: 0;
  border-top: 1px solid black;
  pointer-events: none;
  position: absolute;
  width: 1.4rem;
`;
